import { render, staticRenderFns } from "./ArticleAction.vue?vue&type=template&id=d5432722&"
import script from "./ArticleAction.vue?vue&type=script&lang=js&"
export * from "./ArticleAction.vue?vue&type=script&lang=js&"
import style0 from "./ArticleAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports